import React from "react";
import { PhoneFieldDefinition, SharedFormFieldProps } from "./types";
import { Translated } from "../../../../../../../domain/translations/translations";
import { CheckoutTranslation, type TranslatedValue } from "@swo/storefront";
import { InternalAddress } from "./address";
import cn from "classnames";
import { InputPlaceholder2 } from "../../../shared/form/InputPlaceholder";
import { css } from "@emotion/react";
import { SwarovskiDropdownWithShortLabel } from "../../../shared/SwarovskiDropdown";
import { fontColor, FONTS, fontSize } from "../../../../../../../styles/fonts";
import { CSS_COLORS } from "../../../../../../../styles/styles-css-variables";
import { disabledFormStyles } from "../../../shared/form/DisabledFormStyles";
import { errorMessageStyles } from "../../../shared/form/errorMessageStyles";
import { T } from "../../../../../../../components/T";

export const css1 = css`
  height: 40px;

  position: absolute;
  left: 0;
  top: 0;

  display: grid;
  grid-template-columns: 72px 1fr;
  grid-gap: 4px;
  align-items: center;

  width: 100%;
`;
export const phoneInputInputStyles = [
  FONTS.SwarovskiFutura300,
  fontColor.black,
  fontSize.x2,
  css`
    height: calc(40px - 4px);
    width: 100%;

    padding: 0;
    margin: 0;
    border: none;
    outline: none;
    background-color: inherit;

    &:focus {
      outline: none !important;
    }

    &::placeholder {
      color: ${CSS_COLORS.Grey3};

      ${fontSize.x2};
      ${FONTS.SwarovskiFutura300};
    }

    &:-webkit-autofill,
    &:-webkit-autofill:focus {
      transition:
        background-color 0s 600000s,
        color 0s 600000s !important;
    }
  `,
];
export const phoneInputStyles = [
  FONTS.SwarovskiFutura300,
  fontColor.black,
  fontSize.x2,
  css`
    position: relative;
    height: 40px;

    border: 1px solid var(--so-green);
    border-radius: 12px;

    --bg-color: ${CSS_COLORS.GrayLight2024};
    --text-placeholder-color: ${CSS_COLORS.Grey3};

    &:focus-within {
      outline: 1px solid var(--so-green);
    }

    &:focus-within,
    &.placeholder-visible {
      .placeholder {
        transform: translate(-54px, -18px) scale(0.75);
        transform-origin: center left;
        transition: transform 0.2s ease-out;
      }
    }

    --bg-error: ${CSS_COLORS.GrayLight2024};
    --text-error: ${CSS_COLORS.RedCustom};

    &.has-error {
      --border-color: ${CSS_COLORS.RedCustom};
    }

    .placeholder {
      transition: transform 0.15s ease-out;
      transform-origin: center left;
    }

    &.disabled {
      ${disabledFormStyles};
    }
  `,
];
export const swarovskiDropdownStyles2 = css`
  width: 100%;
  height: calc(40px - 4px);
  border-radius: 12px;

  outline: none;

  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  background: white;

  border-bottom: none;
`;

export const SwarovskiOptikPhoneField: React.FC<{
  def: SharedFormFieldProps & {
    field: PhoneFieldDefinition;
  };
  translations: Translated<CheckoutTranslation>;
  formStateValue: InternalAddress;
  errorMessage?: TranslatedValue | string;
}> = ({ def, translations: t, formStateValue, errorMessage }) => {
  const { field } = def;
  const fieldValue = field.value(formStateValue);
  const onFieldChange = field.onChange;

  const selected = field.dialCodes.find(i => i.value === fieldValue.countryIsoCode) || field.emptyValue;

  return (
    <div
      key={def.key}
      className={cn(
        !!def.disabled ? "disabled" : undefined,
        fieldValue.localPhoneNumber ? "placeholder-visible" : undefined,
        { "has-error": !!errorMessage },
      )}
      css={phoneInputStyles}
    >
      {typeof def.placeholder !== "undefined" && (
        <InputPlaceholder2
          placeholder={def.placeholder}
          required={def.required === "yes-but-without-native-validation" ? true : def.required}
          attachStyles={css`
            position: absolute;
            left: 68px;

            // border
            top: 1px;
            height: calc(100% - 2px);
          `}
        />
      )}

      {errorMessage && (
        <span css={errorMessageStyles}>
          <T>{errorMessage}</T>
        </span>
      )}

      <div css={css1}>
        <SwarovskiDropdownWithShortLabel
          disabled={!!def.disabled}
          required={!!def.required}
          attachStyles={swarovskiDropdownStyles2}
          selected={selected}
          emptyLabel={``}
          name={"phone-dial-code"}
          onChange={str => {
            return onFieldChange({
              ...fieldValue,
              countryIsoCode: str,
            });
          }}
          options={field.dialCodes}
        >
          {selected.shortLabel}
        </SwarovskiDropdownWithShortLabel>

        <input
          type={"tel"}
          required={def.required === "yes-but-without-native-validation" ? false : !!def.required}
          value={fieldValue.localPhoneNumber}
          css={phoneInputInputStyles}
          // placeholder={`${def.placeholder}${def.required ? "*" : ""}`}
          onChange={e => {
            const { value } = e.target;

            return onFieldChange({
              ...fieldValue,
              localPhoneNumber: value,
            });
          }}
        />
      </div>
    </div>
  );
};
